import * as PropTypes from 'prop-types';

export interface Props {
  value: boolean;
  data: object;
}

export const propTypes = {
    value: PropTypes.bool.isRequired,
    data: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./src/components/user-grid/cell/renderers/check/props.ts